export class rolGroup {
    id: number;
    grupo: String
    descripcion: String;
    idEstado: number;
    estado: String;
}